import PropTypes from 'prop-types';

export const payrollsHomePageProps = {};

export const payrollsHomePageType = PropTypes.shape({});
